import { render, staticRenderFns } from "./DsfAddQuestion.vue?vue&type=template&id=01ec544f&"
import script from "./DsfAddQuestion.vue?vue&type=script&lang=js&"
export * from "./DsfAddQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/views/DsfAddQuestion.vue"
export default component.exports